import { useMutation } from 'react-query';
import http from '../http';
import { AxiosResponse } from 'axios';

const endpoint = 'v1/statements/send_email';

type SendStatementsToEmailPayload = {
  company_id: number;
  list_of_statement_reference_number: string[];
  list_of_statement_period_end_date: string[];
  email: string;
};

type SendStatementsToEmailResponse = AxiosResponse<{
  message: string;
}>;

export const postStatementsToEmail = (payload: SendStatementsToEmailPayload) =>
  http.post<SendStatementsToEmailPayload, SendStatementsToEmailResponse>(
    endpoint,
    payload,
  );

export const usePostStatementsToEmail = () =>
  useMutation(postStatementsToEmail);
